const resetBasketTimerEvent = new Event('resetBasketTimer')
export default resetBasketTimerEvent
